import { Box, styled } from "@mui/material";

interface RotatableBoxProps {
  rotated: boolean;
  from: number;
  to: number;
  children: React.ReactNode;
}

const RotatableBox = (props: RotatableBoxProps) => {
  const { rotated, from, to, children } = props;
  return (
    <RotatingBox rotated={rotated} from={from} to={to}>
      {children}
    </RotatingBox>
  );
};

const RotatingBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== "rotated" && prop !== "from" && prop !== "to",
})<Pick<RotatableBoxProps, "rotated" | "from" | "to">>(({ theme, rotated, from, to }) => ({
  display: "inline-flex",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
  transform: rotated ? `rotate(${to}deg)` : `rotate(${from}deg)`,
}));

export default RotatableBox;
